import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeOpen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconHomeOpen"><Path d="M13.6342 2.25094C12.6956 1.44012 11.3044 1.44012 10.3658 2.25094L3.86575 7.86576C3.316 8.34065 3 9.03119 3 9.75765V18.5C3 19.8807 4.11929 21 5.5 21H8.5C9.32843 21 10 20.3284 10 19.5V16.5C10 15.6715 10.6716 15 11.5 15H12.5C13.3284 15 14 15.6715 14 16.5V19.5C14 20.3284 14.6716 21 15.5 21H18.5C19.8807 21 21 19.8807 21 18.5V9.75765C21 9.03119 20.684 8.34065 20.1342 7.86576L13.6342 2.25094Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeOpen;
